/* eslint-disable camelcase */
const NEXTIVA_CX_PRODUCT = 'SocialCloud';
const NEXTIVA_CX_FREE_TRIAL_FEATURE = 'PRODUCT_LED_FREE_TRIAL';

export const getNextivaCXFreeTrialAttributes = (licenses) => {
  const nextivaCXFreeTrialAttributes = {
    trial_activation_date: '',
    trial_expiration_date: '',
    trial_conversion_date: '',
    trial_enablement_date: '',
    trial_state: '',
  };

  licenses?.some((license) => {
    if (license?.product !== NEXTIVA_CX_PRODUCT) return false;

    const featureAttributes = license?.featuresAttributes;

    featureAttributes?.some((featureAttribute) => {
      if (featureAttribute?.name !== NEXTIVA_CX_FREE_TRIAL_FEATURE)
        return false;

      const attributes = featureAttribute?.attributes;

      attributes?.forEach((attribute) => {
        const attributeName = attribute?.name;
        const attributeValue = attribute?.value;

        switch (attributeName) {
          case 'STATE':
            nextivaCXFreeTrialAttributes.trial_state = attributeValue;
            break;
          case 'ENABLEMENT_DATE':
            nextivaCXFreeTrialAttributes.trial_enablement_date = attributeValue;
            break;
          case 'CONVERSION_DATE':
            nextivaCXFreeTrialAttributes.trial_conversion_date = attributeValue;
            break;
          case 'ACTIVATION_DATE':
            nextivaCXFreeTrialAttributes.trial_activation_date = attributeValue;
            break;
          case 'EXPIRATION_DATE':
            nextivaCXFreeTrialAttributes.trial_expiration_date = attributeValue;
            break;
          default: // No action needed
        }
      });

      return true;
    });

    return true;
  });

  return nextivaCXFreeTrialAttributes;
};
